// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__f6QiC","title":"styles_title__VU81+","message":"styles_message__Covx2","exit":"styles_exit__UU5oF"};